module.exports = __webpack_public_path__ + "static/img/menu3.04a3d34f.png";